module.exports = __webpack_public_path__ + "img/112.1024ab05.jpg";